import { ContentIcon } from './content-icon.component';

export * from './content-icon.component';
export default ContentIcon;

ContentIcon.define('der-ui-content-icon');

declare global {
    interface HTMLElementTagNameMap {
        'der-ui-content-icon': ContentIcon;
    }
}
